<template>
  <div :class="$style.wrapper">
    <div :class="$style.header">
      <img
        v-if="this.$store.state.isAdmin"
        :class="this.$store.state.admin ? $style.logoColor : null"
        src="../assets/img/logo.svg"
        alt=""
        @click="toggleMode"
      />
      <img v-else src="../assets/img/logo.svg" alt="" />
      <div :class="$style.search">
        <img src="../assets/img/search.svg" alt="" />
        <input v-model="search" type="text" placeholder="Поиск" />
        <button v-if="search" :class="$style.clear" @click="search = ''" aria-label="Очистить">
          <svg viewBox="0 0 20 20" width="18" height="18">
            <circle cx="10" cy="10" r="9" fill="#3a3a3a" />
            <path
              d="M6.5 6.5l7 7M13.5 6.5l-7 7"
              stroke="#f7f7f7"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
    <div :class="$style.filter">
      <button
        v-for="(button, index) in buttons"
        :key="button"
        @click="changeCategory(index)"
        :class="button.active ? $style.active : null"
      >
        {{ button.title }}
      </button>
    </div>
    <div :class="$style.catalog">
      <Catalog :objects="searchProducts" />
    </div>
  </div>
</template>

<script>
import Catalog from '../components/Catalog.vue';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      search: '',
      activeCategory: [],
      categories: {
        all: [],
        newBuildings: [],
        secondary: [],
        commercial: [],
      },
      buttons: [
        {
          title: 'Все',
          active: true,
          category: 'all',
        },
        {
          title: 'Новостройки',
          active: false,
          category: 'newBuildings',
        },
        {
          title: 'Вторичные',
          active: false,
          category: 'secondary',
        },
        {
          title: 'Коммерция',
          active: false,
          category: 'commercial',
        },
      ],
    };
  },
  components: {
    Catalog,
  },
  async mounted() {
    window.Telegram.WebApp.ready();
    window.Telegram.WebApp.expand();
    this.$store.commit('changeLoading', true);
    await this.$store.dispatch('checkInitData', {
      _auth: window.Telegram.WebApp.initData,
    });
    await this.$store.dispatch('getObjects');

    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category') || localStorage.getItem('activeCategory');

    if (category) {
      this.selectCategoryByName(category);
    } else {
      this.activeCategory = this.categories.all;
    }

    this.$store.commit('changeLoading', false);
  },
  methods: {
    toggleMode() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
      this.$store.commit('toggleAdmin');
    },

    filterObjects() {
      this.categories.all = [];
      this.categories.newBuildings = [];
      this.categories.secondary = [];
      this.categories.commercial = [];

      this.sortObjects(this.objects);
      for (let i = 0; i < this.buttons.length; i++) {
        if (this.buttons[i].active) {
          this.changeCategory(i);
        }
      }
    },
    sortObjects(objects) {
      for (let i = 0; i < objects.length; i++) {
        switch (objects[i].category) {
          case 'Новостройки':
            this.categories.newBuildings.push(objects[i]);
            break;
          case 'Вторичные':
            this.categories.secondary.push(objects[i]);
            break;
          case 'Коммерция':
            this.categories.commercial.push(objects[i]);
            break;
        }
      }
      this.categories.all = [
        ...this.categories.newBuildings,
        ...this.categories.secondary,
        ...this.categories.commercial,
      ];
    },
    changeCategory(index) {
      this.buttons.forEach((button, i) => {
        button.active = i === index;
      });
      this.activeCategory = this.categories[this.buttons[index].category];

      localStorage.setItem('activeCategory', this.buttons[index].category);

      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },

    selectCategoryByName(categoryName) {
      const index = this.buttons.findIndex((button) => button.category === categoryName);
      if (index !== -1) {
        this.changeCategory(index);
      }
    },
  },
  computed: {
    searchProducts() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.activeCategory;
      // ищем по названию, категории, описанию (без HTML-тегов) и ID
      return this.activeCategory.filter((p) => {
        const text = [p.header, p.category, (p.description || '').replace(/<[^>]+>/g, ' '), p.id]
          .join(' ')
          .toLowerCase();
        return text.indexOf(q) !== -1;
      });
    },
    ...mapState(['objects', 'admin']),
  },
  watch: {
    objects() {
      this.filterObjects();
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
}

.wrapper {
  padding: 16px 0;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    opacity: 100%;
    animation-name: show;
    animation-duration: 1s;
    .logoColor {
      filter: contrast(0);
      transition: all 0.2s ease;
    }
    img {
      filter: contrast(1);
      margin: 0 16px 0 0;
      transition: all 0.2s ease;
    }
    .search {
      display: flex;
      align-items: center;
      width: 100%;
      background-color: $bg-dark;
      border-radius: 24px;
      padding: 0 16px;
      img {
        margin-right: 16px;
      }
      .clear {
        flex: 0 0 auto;
        margin-left: 8px;
        background: transparent;
        border: none;
        padding: 0;
        display: flex;
        cursor: pointer;
      }
      input {
        color: $white;
        font-size: 14px;
        width: 100%;
        &::placeholder {
          color: $muted;
        }
        background-color: transparent;
        padding: 14px 0;
        border: none;
        outline: none;
      }
    }
  }
  .filter {
    display: flex;
    padding: 16px 0 16px 16px;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    opacity: 100%;
    animation-name: show;
    animation-duration: 1s;
    &::-webkit-scrollbar {
      display: none;
    }
    button {
      background-color: $bg-dark;
      border-radius: 12px;
      border: none;
      outline: none;
      color: $primary-light;
      padding: 7px 12px;
      margin-right: 8px;
      cursor: pointer;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 10px;
      letter-spacing: 1px;
      transition: all 0.2s ease-in-out;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        transition: all 0.2s ease-in-out;
        background-color: $primary;
        color: $white;
      }
    }
  }
  .catalog {
    padding: 0 16px;
  }
}
</style>
